export enum AysClinicMedicalCareLevel {
    /**
     * Grund- & Regelversorgung
     */
    BASIC_REGULAR_PROVIDER = 'BASIC_REGULAR_PROVIDER',

    /**
     * Fachkrankenhaus
     */
    SPECIALIZED_HOSPITAL = 'SPECIALIZED_HOSPITAL',

    /**
     * Schwerpunktversorgung
     */
    FOCUS_PROVIDER = 'FOCUS_PROVIDER',

    /**
     * Maximalversorgung
     */
    MAXIMUM_PROVIDER = 'MAXIMUM_PROVIDER'
}

export const AYS_CLINIC_MEDICAL_CARE_LEVEL_DISPLAY_NAMES = {
    BASIC_REGULAR_PROVIDER: 'Grund- & Regelversorger',
    FOCUS_PROVIDER: 'Schwerpunktversorger',
    SPECIALIZED_HOSPITAL: 'Fachkrankenhaus',
    MAXIMUM_PROVIDER: 'Maximalversorger',
}
